module.exports = __webpack_public_path__ + "img/7-Menopause.c3f61800.png";